import { AccountCircleOutlined, Menu } from '@mui/icons-material';
import {
  AppBar,
  Button,
  Container,
  IconButton,
  Stack,
  Toolbar,
  Typography,
} from '@mui/material';
import { useWorkspaceId } from 'api/providers/workspaceProvider';
import { DockProvider } from 'components/dock/provider';
import Sidebar from 'components/sidebar';
import { useIsTablet } from 'hooks/useIsMobile';
import React, { useState } from 'react';

import Search from './search';

export default function Header(props: React.PropsWithChildren) {
  const isMobile = useIsTablet();
  const workspaceId = useWorkspaceId();

  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <>
      <AppBar position="fixed" sx={{ zIndex: 1300 }}>
        <Toolbar sx={{ minHeight: '48px !important' }}>
          <Container maxWidth="lg">
            <Stack
              height="100%"
              flexGrow={1}
              direction="row"
              alignItems="stretch"
              justifyContent="space-between"
            >
              <Stack direction="row" alignItems="centers">
                {isMobile && (
                  <Stack mr={1}>
                    <IconButton onClick={() => setDrawerOpen(true)}>
                      <Menu />
                    </IconButton>
                  </Stack>
                )}
                <Button href={`/workspace/${workspaceId}`}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    gap={1.5}
                  >
                    <img
                      src="/blackframe.png"
                      alt="logo"
                      width={24}
                      height={24}
                    />

                    <Typography
                      color="white"
                      lineHeight={1}
                      fontSize="1.5em"
                      fontWeight="800"
                      // textTransform="none"
                      letterSpacing={3}
                    >
                      BlackFrame
                    </Typography>
                  </Stack>
                </Button>
              </Stack>
              {!isMobile && <Search />}
              <Stack direction="row" alignItems="center">
                <IconButton>
                  <AccountCircleOutlined />
                </IconButton>
              </Stack>
            </Stack>
          </Container>
        </Toolbar>
      </AppBar>
      <Stack height="100%">
        <DockProvider>
          <Stack direction="row" flexShrink={1} flexGrow={1} minHeight={0}>
            <Sidebar open={drawerOpen} onClose={() => setDrawerOpen(false)} />
            <Stack flexGrow={1} height="100%" overflow="auto" px={3}>
              <Toolbar />
              {props.children}
            </Stack>
          </Stack>
        </DockProvider>
      </Stack>
    </>
  );
}
